var _rect, _path, _rect2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstallation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 520,
    viewBox: "0 0 800 520",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#5568d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6a3d8f"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "url(#g4)",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255,255,255,0.35)",
    d: "M380 140 L460 220 L420 220 L420 380 L360 380 L360 220 L320 220 Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 320,
    width: 120,
    height: 12,
    rx: 4,
    fill: "rgba(255,255,255,0.25)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 260,
    r: 8,
    fill: "rgba(255,255,255,0.6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallation);
export default __webpack_public_path__ + "static/media/installation.fcb01208f785ed76096452dd2c47d41c.svg";
export { ForwardRef as ReactComponent };